import React from "react";
import { Box, Grid, Typography, IconButton } from "@mui/material";
import { YouTube, Facebook, Twitter, Instagram } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/icons/logo (2).png";

const Footer = () => {
  const navigate = useNavigate();

  const navigationRoutes = {
    Home: "/",
    Community: "/community",
    "Training Hub": "/calendar",
    Profile: `/creator/${1}`, // Dynamic user ID can be passed here
  };

  return (
    <Box
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        py: { xs: 4, md: 6 },
        px: { xs: 2, md: 10 },
        borderTop: "4px solid #FC0108",
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Far Left - Social Icons */}
        <Grid item xs={12} sm={3}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#FC0108", mb: 2 }}
          >
            Follow Us
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            {[YouTube, Facebook, Twitter, Instagram].map((Icon, idx) => (
              <IconButton
                key={idx}
                sx={{
                  color: "#fff",
                  transition: "0.3s",
                  "&:hover": { color: "#FC0108" },
                }}
                href="#"
              >
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Box>
        </Grid>

        {/* ✅ Fixed Middle Left - Navigation */}
        <Grid item xs={12} sm={3}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#FC0108", mb: 2 }}
          >
            Navigation
          </Typography>
          {Object.keys(navigationRoutes).map((text, idx) => (
            <Typography
              key={idx}
              sx={{
                cursor: "pointer",
                transition: "0.3s",
                "&:hover": { color: "#FC0108" },
              }}
              onClick={() => navigate(navigationRoutes[text])}
            >
              {text}
            </Typography>
          ))}
        </Grid>

        {/* Middle Right - Policies */}
        <Grid item xs={12} sm={3}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#FC0108", mb: 2 }}
          >
            About
          </Typography>
          {[
            "Press",
            "Careers",
            "Privacy Policy",
            "Terms & Conditions",
            "Accessibility",
          ].map((item, idx) => (
            <Typography
              key={idx}
              sx={{
                transition: "0.3s",
                "&:hover": { color: "#FC0108" },
              }}
            >
              {item}
            </Typography>
          ))}
        </Grid>

        {/* Far Right - Logo */}
        <Grid
          item
          xs={12}
          sm={3}
          sx={{ textAlign: { xs: "center", sm: "right" } }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ width: "140px", filter: "brightness(1.2)" }}
          />
        </Grid>
      </Grid>

      {/* Bottom text */}
      <Box
        sx={{
          textAlign: "center",
          mt: 4,
          fontSize: "14px",
          opacity: 0.7,
        }}
      >
        © {new Date().getFullYear()} Only Hands. All Rights Reserved.
      </Box>
    </Box>
  );
};

export default Footer;
